<template>
  <div class="container bottom-fix-padding">
    <div class="navi">
        <span class="icon-arrow-left" @click="goback()"></span>
    </div>

    <div class="title">请确认订单详情</div>

    <img class="prepay-img" src='../../assets/img/other/prepay-amount.png'>

      <div class="weui-cells__title">预计价格（仅作参考，以实际服务为准）</div>

      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>基础服务费</p>
            </div>
            <div class="weui-cell__ft" v-if="pricing.labor_cost">{{pricing.labor_cost | numeral('$0,0.00')}}</div>
            <div class="weui-cell__ft" v-if="pricing.labor_cost==0">户型特殊，客服将电话回访报价</div>
        </a>
        <a class="weui-cell" href="javascript:;" v-if="pricing.duplex_cost">
            <div class="weui-cell__bd">
                <p>复式户型费</p>
            </div>
            <div class="weui-cell__ft">
              <span v-if="pricing.duplex_cost">{{pricing.duplex_cost | numeral('$0,0.00')}}</span>
            </div>
        </a>
        <a class="weui-cell" href="javascript:;" v-if="pricing.carpet_cost">
            <div class="weui-cell__bd">
                <p>地毯清洁费</p>
            </div>
            <div class="weui-cell__ft">
              <span v-if="pricing.carpet_cost">{{pricing.carpet_cost | numeral('$0,0.00')}}</span>
            </div>
        </a>
        <a class="weui-cell" href="javascript:;"  v-if="pricing.special_cost">
            <div class="weui-cell__bd">
                <p>特殊区域：车库</p>
            </div>
            <div class="weui-cell__ft">
              <span>{{pricing.special_cost | numeral('$0,0.00')}}</span>
            </div>
        </a>
        <a class="weui-cell" href="javascript:;"  v-if="order.data.storage||order.data.swimming_pool||order.data.forecourt||order.data.backyard">
            <div class="weui-cell__bd">
                <p>
                  <span v-show="order.data.storage">仓库 </span>
                  <span v-show="order.data.swimming_pool">泳池 </span>
                  <span v-show="order.data.forecourt">前院 </span>
                  <span v-show="order.data.backyard">后院 </span>
                </p>
            </div>
            <div class="weui-cell__ft" >视现场情况收费</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>GST费用</p>
            </div>
            <div class="weui-cell__ft">
              <span>总费用10%</span>
            </div>
        </a>
        <label class="weui-cell weui-check__label car">
            <div class="weui-cell__bd">
                <p class="park-assist" @click="goto('/clean-pricing')"> <span class="icon-info parking-icon"></span> 点击查看收费标准 </p>
            </div>
        </label>
      </div>
      <div class="weui-cells__title">优惠券</div>
      <div class="weui-cells coupon-cell">
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/coupon-apply')">
            <div class="weui-cell__bd">
                <p>优惠券</p>
            </div>
            <div class="weui-cell__ft" v-if="order.data.coupon_id">{{order.data.coupon_title | uppercase}}</div>
            <div class="weui-cell__ft" v-else> <span class="icon-coupon"></span> 点击使用 </div>
        </a>
      </div>

      <div class="weui-cells__title">服务详情，点击可修改</div>
      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>服务类型</p>
            </div>
            <div class="weui-cell__ft">退房清洁</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/clean-step1')">
            <div class="weui-cell__bd">
                <p>清洁户型</p>
            </div>
            <div class="weui-cell__ft">{{house_type_duplex}}</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/clean-step2')">
            <div class="weui-cell__bd">
                <p>清洁房间</p>
            </div>
            <div class="weui-cell__ft">{{room_qty}}</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/clean-step3')">
            <div class="weui-cell__bd">
                <p>特殊区域</p>
            </div>
            <div class="weui-cell__ft">{{sp_room}}</div>
        </a>

        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/clean-step5')">
            <div class="weui-cell__bd">
                <p>服务时间</p>
            </div>
            <div class="weui-cell__ft">{{order.data.service_date | moment("YYYY年M月D日")}} {{service_period}}</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/clean-step4')">
            <div class="weui-cell__bd">
                <p>清洁地址</p>
            </div>
            <div class="weui-cell__ft">{{order.data.address_street}}, {{order.data.address_suburb}}, {{order.data.address_state}}, {{order.data.address_postcode}}<br>{{toTextFloor(order.data.floor)}} {{toTextParking(order.data.parking)}}</div>
        </a>
      </div>
      <div class="weui-cells__title">留言备注</div>
      <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
              <div class="weui-cell__bd">
                  <textarea class="weui-textarea" placeholder="如果有特殊需求，请在此备注留言" rows="2"  v-model="order.data.msg"></textarea>
              </div>
          </div>
      </div>
      <div class="weui-cells__title">中介推荐码</div>
      <div class="weui-cells">
          <div class="weui-cell">
              <div class="weui-cell__bd">
                  <input class="weui-input" type="text" placeholder="如果由中介推荐，请输入中介推荐码" v-model="order.data.agency">
              </div>
          </div>
      </div>
      <br>
      <div class="btn-box-fix">
        <div class="btn-container">
          <div class="btn active" @click="isSubmiting=true">创建订单</div>
        </div>
      </div>
      <div class="js_dialog" v-show="isSubmiting">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__hd"><strong class="weui-dialog__title">温馨提醒</strong></div>
              <div class="weui-dialog__bd">请确保服务信息无误，提交后信息将被锁定，只能联系客服修改</div>
              <div class="weui-dialog__ft">
                  <div  class="weui-dialog__btn weui-dialog__btn_default" @click="isSubmiting=false">关闭</div>
                  <div class="weui-dialog__btn weui-dialog__btn_daojia" @click="submitOrder()">确定提交</div>
              </div>
          </div>
      </div>

      <transition name="fade">
          <div id="loadingToast" v-show="isSendingPricing">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在获取报价</p>
              </div>
          </div>
      </transition>
      <transition name="fade">
          <div id="loadingToast" v-show="isSending">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在提交</p>
              </div>
          </div>
      </transition>
      <img :src="pixelURL('clean','xiadan')" class="hide">
    </div>
</template>

<script>
import qs from 'qs'
import Vue from 'vue'

export default {
  name: 'finalStep',
  data () {
    return {
      order:{},
      isSending:false,
      isSendingPricing:false,
      isSubmiting:false,
      pricing:{},
    }
  },
  methods: {
    editData(url){
      localStorage.isEditing = '/clean-step7';
      this.$router.push(url);
    },
    goback(){
      if(this.$route.query.src == 'order'){
        this.$router.push('/order');
      }
      else{
        this.$router.push('/clean-step5');
      }
    },

    getPricing(){
      if(this.isSendingPricing){
        return false;
      }
      else{
        this.isSendingPricing = true;
        let that = this;

        //做对象的副本出来
        let orderObject =  JSON.parse(JSON.stringify(this.order.data));

        orderObject.type_id = 1550735960;

        if(orderObject.is_duplex=="0"){
          orderObject.duplex_floor = 0;
        }

        orderObject.duplex_floor = this.dataLint("duplex_floor",orderObject.duplex_floor);
        orderObject.floor = this.dataLint("floor",orderObject.floor);
        orderObject.carpet = this.dataLint("carpet",orderObject.carpet);

        console.log(orderObject);

        this.axios.post(this.apiURL()+'/Cost/getCost', qs.stringify(orderObject))
        .then(function (response) {
          console.log(response);
          if(response.data.error_code==0){
            that.pricing = response.data.data;
            that.isSendingPricing=false;
          }
          else{
            alert("提交失败："+response.data.data)
            that.isSendingPricing=false;
          }
        })
        .catch(function (error) {
          alert("获取报价失败，请检查网络并尝试刷新页面")
          that.isSendingPricing=false;
          console.log(error);
        });
      }
    },
    submitOrder(){
      this.isSubmiting = false;
      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;

        this.orderUpdate('agency',this.order.data.agency)
        this.orderUpdate('msg',this.order.data.msg)

        //做对象的副本出来
        let orderObject =  JSON.parse(JSON.stringify(this.order.data));

        //往备注里补充用户第一页选择的服务详情
        orderObject.msg = orderObject.msg + " " + this.order.data.msgAttach;

        orderObject.type_id = 1550735960;

        if(this.checkLogin()){
            orderObject.token = localStorage.token;
            orderObject.member_name = localStorage.member_name;
            orderObject.member_phone = localStorage.member_phone;
            orderObject.member_mail = localStorage.member_mail;
        }
        else{
            orderObject.token = 0;
            orderObject.member_name = orderObject.address_name;
            orderObject.member_phone = orderObject.address_phone;
        }

        orderObject.service_date = new Date(orderObject.service_date);
        orderObject.service_date = Vue.filter('moment')(orderObject.service_date,"YYYY-MM-DD");

        if(orderObject.is_duplex=="0"){
          orderObject.duplex_floor = 0;
        }

        orderObject.house_type = this.dataLint("house_type",orderObject.house_type);
        orderObject.duplex_floor = this.dataLint("duplex_floor",orderObject.duplex_floor);
        orderObject.floor = this.dataLint("floor",orderObject.floor);
        orderObject.parking = this.dataLint("parking",orderObject.parking);
        orderObject.carpet = this.dataLint("carpet",orderObject.carpet);

        orderObject['order_source'] = '3';


        console.log(orderObject);

        this.axios.post(this.apiURL()+'/Order/createOrder', qs.stringify(orderObject))
        .then(function (response) {
          console.log(response);
          if(response.data.error_code==0){
            localStorage.removeItem('savedClean');
            localStorage.removeItem('order');

            let modalString = "";
            if(that.pricing.labor_cost==0){
              modalString = "&notify=clean-rooms";
            }


            localStorage.is_questions = response.data.data.is_questions;
            localStorage.phone_question = orderObject.member_phone;
            localStorage.questions = JSON.stringify(response.data.data.questions);

            that.$router.push('/order-prepay?id='+response.data.data.order_number+'&status=0&amount='+that.depositAmount()+modalString);
            if(response.data.data.accoun_status>=0){
              localStorage.account_status = response.data.data.accoun_status;
            }

            if(response.data.data.accoun_status == 2){
              localStorage.token = response.data.data.token;
              localStorage.member_phone = response.data.data.phone;
              localStorage.member_name = response.data.data.name;
              localStorage.tempPasswd = response.data.data.password;
            }
          }
          else{
            alert("提交失败："+response.data.data)
            that.isSending=false;
          }
        })
        .catch(function (error) {
          alert("提交失败，请检查网络并重新尝试")
          that.isSending=false;
          console.log(error);
        });
      }
    },
    dataLint(name,value){
      let result ="";

      if (name == "duplex_floor"){
        switch (value) {
          case 0:
            result = "0"
            break;
          case 2:
            result = "1558077283"
            break;
          case 3:
            result = "1558077310"
            break;
          case 4:
            result = "1558077329"
            break;
          case 5:
            result = "1558077340"
            break;
          default:
            console.log("5");
        }
      }

      if (name == "house_type"){
        switch (value) {
          case "1":
            result = "1552109724"
            break;
          case "2":
            result = "1552109729"
            break;
          case "3":
            result = "1552109735"
            break;
          case "4":
            result = "1552109742"
            break;
          case "5":
            result = "1558079273"
            break;
          case "6":
            result = "1552109747"
            break;
          default:
            console.log("5");
        }
      }

      if (name == "parking") {
        switch (value) {
          case "1":
            result = "1551410080"
            break;
          case "2":
            result = "1551410087"
            break;
          case "3":
            result = "1551410093"
            break;
          default:
            console.log("6");
        }
      }

      if (name == "floor") {
        switch (value) {
          case "1":
            result = "1551412462"
            break;
          case "2":
            result = "1551412475"
            break;
          case "3":
            result = "1551412486"
            break;
          case "4":
            result = "1551412499"
            break;
          case "5":
            result = "1551412509"
            break;
          case "6":
            result = "1551412525"
            break;
          case "7":
            result = "1551412535"
            break;
          default:
            console.log("7");
        }
      }

      if (name == "carpet") {
        switch (value) {
          case 0:
            result = "0"
            break;
          case 1:
            result = "1564040798"
            break;
          case 2:
            result = "1564040821"
            break;
          case 3:
            result = "1564040831"
            break;
          case 4:
            result = "1564040842"
            break;
          case 5:
            result = "1564040857"
            break;
          default:
            console.log("8");
        }
      }
      return result;
    },

    toTextParking(theVar){
      let result = '';
      switch (theVar) {
        case "1":
          result = '我有停车位'
          break;
        case "2":
          result = '已约停车位'
          break;
        case "3":
          result = '无法提供停车位'
          break;
        default:
          console.log("9");
      }
      return result;
    },
    toTextFloor(theVar){
      let result = '';
      switch (theVar) {
        case "1":
          result = '有电梯/住G层'
          break;
        case "2":
          result = '1层 无电梯'
          break;
        case "3":
          result = '2层 无电梯'
          break;
        case "4":
          result = '3层 无电梯'
          break;
        case "5":
          result = '4层 无电梯'
          break;
        case "6":
          result = '5层 无电梯'
          break;
        case "7":
          result = '5层以上 无电梯'
          break;
        default:
          console.log("8");
      }
      return result;
    },
  },
  components: {
  },
  computed: {
    service_period: function () {
      let result = '';
      switch (this.order.data.service_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },

    house_type_duplex: function () {
      let type = '';
      let duplex = '';
      switch (this.order.data.house_type) {
        case "1":
          type = 'Apartment'
          break;
        case "2":
          type = 'Unit'
          break;
        case "3":
          type = 'House'
          break;
        case "4":
          type = 'Town House'
          break;
        case "5":
          type = 'Studio'
          break;
        case "6":
          type = 'Other'
          break;
        default:
          console.log("2");
      }
      switch (this.order.data.is_duplex) {
        case "0":
          duplex = '非复式'
          break;
        case "1":
          duplex = '复式'
          break;
        default:
          console.log("2");
      }
      let result = type + " " + duplex;
      if(this.order.data.is_duplex=="1"){
        result = result + this.order.data.duplex_floor + "层"
      }
      return result;
    },
    room_qty: function () {
      let result = this.order.data.livingroom + '厅 ' + this.order.data.bedroom + '室 ' + this.order.data.bathroom + '卫浴 ' + this.order.data.toiletroom + '厕所 ';
      if(this.order.data.carpet>0){
        result = result + this.order.data.carpet + "房地毯"
      }
      result =  result.replace(/more/g, '多')
      return result;
    },
    sp_room: function () {
      let result ='';

      if(this.order.data.garage>0){
        result = result + this.order.data.garage + '车库 ';
      }
      if(this.order.data.storage>0){
        result = result + this.order.data.storage + '仓库 ';
      }
      if(this.order.data.swimming_pool>0){
        result = result + this.order.data.swimming_pool + '泳池 ';
      }
      if(this.order.data.forecourt>0){
        result = result + this.order.data.forecourt + '前院 ';
      }
      if(this.order.data.backyard>0){
        result = result + this.order.data.backyard + '后院 ';
      }
      if(result==''){
        result = "无";
      }
      return result;
    },

  },
  created: function () {
    //如果LS存在老的下单信息
    if (localStorage.savedClean){
      //如果LS不存在order字段，则将老下单信息覆盖LS的order字段
      if(!localStorage.order){
        localStorage.order = localStorage.savedClean;
      }//如果LS存在order字段，判断其是否属于当前服务类型：如果否，则将老下单信息覆盖LS的order字段
      if(localStorage.order){
        let localParsed = JSON.parse(localStorage.order);
        if(localParsed.service != "clean"){
          localStorage.order = localStorage.savedClean;
        }
      }
    }
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "clean"){
        this.order = localParsed;
        this.userCatch("1550735960",this.order.data.address_name,this.order.data.address_phone);
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
    this.getPricing();
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ .weui-cell__ft{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width:70%;
  font-size:0.9em;
}

.mini-title{
  margin-top:20px;
  color: #595D68;
  font-size: 12pt;
  text-align: center;
  font-weight: bold;
}

.park-assist{
    text-align:center;
    color:#fe9567;
}

.prepay-img{
  width:100%;
}

.container /deep/{

  .couponPd{
    padding-top:0;
    padding-bottom:0;
  }

  .weui-vcode-btn{
    padding-right:0;
    margin-left:10px;
    color:#ff7444;
  }

  .weui-cell_access .weui-cell__ft:after{
    border-color: #FE956A;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/clean/step7.vue